import { CheckoutContainer } from './CheckoutContainer';
import {
  CheckoutContainerProps,
  OnboardServicesByCruiseIdMyMSCResponseI,
} from '@msc-b2c/interfaces/types';
import { useEffect, useState } from 'react';
import { getPricesCart } from '../utils/getPricesCart';
import {
  AppDispatch,
  getActiveSession,
  RootState,
  updateCartPrices,
  useGetBookingQuery,
} from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';
import { useDispatch, useSelector } from 'react-redux';
import { GetExcursionsMyMSCResponse } from '@msc-b2c/interfaces/interfaces';
import { useNavigate } from 'react-router-dom';
import { redirectToCartWithAvailabilityError } from '../utils/cartAvailabilityUtils';

export function CheckoutContainerWrapper(props: Readonly<CheckoutContainerProps>) {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { bookingNumber = '', cruiseId } = getActiveSession();
  const { data: booking } = useGetBookingQuery(bookingNumber !== '' ? bookingNumber : skipToken);
  const { items: cart, prices } = useSelector((state: RootState) => state.myAreaCart);
  const myMscExcursions: GetExcursionsMyMSCResponse | null =
    useSelector((state: RootState) => state.myCruise.excursions) || null;
  const myMscObs: OnboardServicesByCruiseIdMyMSCResponseI | null =
    useSelector((state: RootState) => state.myCruise.obs) || null;

  const { is3dsFlow } = useSelector((state: RootState) => state.payment);

  const removeCartSkeleton = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    if (cart.length === 0 || is3dsFlow) {
      removeCartSkeleton();
      if (is3dsFlow) {
        setIsLoading(false);
      }
    } else if (isLoading && booking && myMscExcursions !== null && myMscObs !== null && cruiseId) {
      // Drop cart-page prices so checkout always works off a fresh prices response.
      // If the fetch fails, Payment falls back to onPriceToBook instead of a stale transactionId.
      dispatch(updateCartPrices(null));
      getPricesCart(dispatch, cruiseId, bookingNumber, false, undefined, {
        onCartAvailabilityError: (issueCode) => {
          redirectToCartWithAvailabilityError(issueCode, props.emptyCartRedirectionLink, navigate);
        },
      })
        .catch(() => undefined)
        .finally(() => setIsLoading(false));
    }
  }, [
    booking,
    cruiseId,
    dispatch,
    is3dsFlow,
    isLoading,
    myMscExcursions,
    myMscObs,
    navigate,
    props.emptyCartRedirectionLink,
  ]);

  return !isLoading && (prices || is3dsFlow || cart.length > 0) && <CheckoutContainer {...props} />;
}

CheckoutContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/checkoutcontainer';
export default CheckoutContainerWrapper;
